import styled from 'styled-components';

export const LabelContainer = styled.div`
  width: 100%;
  display: flex;

  justify-content: ${({ hasSuffix }: { hasSuffix: boolean }) =>
    hasSuffix ? 'space-between' : 'flex-start'};

  align-items: flex-start;
`;
